import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=29474955"
import script from "./ButtonList.vue?vue&type=script&lang=js"
export * from "./ButtonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29474955')) {
      api.createRecord('29474955', component.options)
    } else {
      api.reload('29474955', component.options)
    }
    module.hot.accept("./ButtonList.vue?vue&type=template&id=29474955", function () {
      api.rerender('29474955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/extension/ButtonList.vue"
export default component.exports